import type { SxProps, Theme } from "@mui/material/styles";

export type LmsStatusTone =
  | "neutral"
  | "success"
  | "warning"
  | "error"
  | "info";

/** Text and background pairs for LMS status labels (cards, chips, pills). */
export const LMS_STATUS_TONE_CSS: Record<
  LmsStatusTone,
  { color: string; backgroundColor: string }
> = {
  neutral: {
    color: "#555555",
    backgroundColor: "#f3eff7",
  },
  success: {
    color: "#16794f",
    backgroundColor: "#e9f8f0",
  },
  warning: {
    color: "#9a5b00",
    backgroundColor: "#fff4e5",
  },
  error: {
    color: "#a63333",
    backgroundColor: "#fdecec",
  },
  info: {
    color: "#1d5fbf",
    backgroundColor: "#edf4ff",
  },
};

export function lmsStatusToneChipSx(
  tone: LmsStatusTone,
): SxProps<Theme> {
  const { color, backgroundColor } = LMS_STATUS_TONE_CSS[tone];
  return {
    color,
    backgroundColor,
    border: "none",
    "& .MuiChip-icon": { color },
  };
}
